import { render, staticRenderFns } from "./InfluencerTransferPage.vue?vue&type=template&id=18d87fa7&"
import script from "./InfluencerTransferPage.vue?vue&type=script&lang=js&"
export * from "./InfluencerTransferPage.vue?vue&type=script&lang=js&"
import style0 from "./InfluencerTransferPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports